import { gql, useQuery } from '@apollo/client';
import { getBackendLanguage, translateBackend } from '@assets/i18n/config';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const FETCH_CLIENT_REPORT_NAME = gql`
  query fetchClientReportTemplate($clientReportTemplateId: ObjectID!) {
    fetchClientReportTemplate(clientReportTemplateId: $clientReportTemplateId) {
      clientReportTemplate {
        translatedName { ${getBackendLanguage()} }
      }
    }
  }
`;

export function ClientReportBreadcrumb() {
  const { t } = useTranslation('clientReportTemplate');
  const { clientReportTemplateId } = useParams();

  const { data } = useQuery(FETCH_CLIENT_REPORT_NAME, {
    variables: { clientReportTemplateId },
  });

  const clientReportName =
    data?.fetchClientReportTemplate?.clientReportTemplate?.translatedName;

  return clientReportName
    ? translateBackend(clientReportName)
    : t('clientReport');
}
